import React from "react";
import { Link } from "react-router-dom";

const AuthFooter: React.FC = () => {
  return (
   <div className="mt-5 text-text-secondary border-t border-gray-200 pt-4 pb-4 text-center text-xs">
      <span>© {new Date().getFullYear()} Sinecure.ai — All Rights Reserved. </span>
      <Link
        to="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="ml-2 text-primary hover:text-primary-dark transition-colors"
      >
        Privacy Policy
      </Link>
    </div>
  );
};

export default AuthFooter;
